import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

type Props = {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
};

const ForumConfirmDialog: React.FC<Props> = ({
  open,
  title = 'Emin misiniz?',
  message,
  confirmLabel = 'Sil',
  cancelLabel = 'Vazgeç',
  onConfirm,
  onCancel,
  loading,
}) => (
  <AnimatePresence>
    {open && (
      <motion.div
        className="forum-modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => !loading && onCancel()}
      >
        <motion.div
          className="forum-confirm-dialog glow-card"
          initial={{ scale: 0.94, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.94, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="forum-confirm-dialog__icon">
            <AlertTriangle size={22} />
          </div>
          <h3>{title}</h3>
          <p>{message}</p>
          <div className="forum-confirm-dialog__actions">
            <button type="button" className="forum-btn forum-btn--ghost" onClick={onCancel} disabled={loading}>
              {cancelLabel}
            </button>
            <button type="button" className="forum-btn forum-btn--danger" onClick={onConfirm} disabled={loading}>
              {loading ? 'Siliniyor…' : confirmLabel}
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default ForumConfirmDialog;
